import { Typography } from '@jouzen/ecom-components/v3/Typography';
import { useTranslations } from 'next-intl';

export const AccessAndUseSection = () => {
  const t = useTranslations();
  return (
    <>
      <Typography Element="h2" variant="h3">
        {t('terms_access_title')}
      </Typography>
      <Typography>{t('terms_access_p_1')}</Typography>
      <Typography>{t('terms_access_p_2')}</Typography>
      <Typography>{t('terms_access_p_3')}</Typography>
      <Typography>{t('terms_access_p_4')}</Typography>
      <Typography>{t('terms_access_p_5')}</Typography>
      <Typography>{t('terms_access_p_6')}</Typography>
      <Typography>{t('terms_access_p_7')}</Typography>
      <Typography>{t('terms_access_p_8')}</Typography>
    </>
  );
};
